import styled from 'styled-components';

export const StyledImageWrapper = styled.div`
  position: relative;
  display: block;
  & img {
    width: 100%;
  }
  @media (min-width: calc(${({ theme }) => theme.screenBreakpoints.small} + 0.2px)) and (max-width: ${({ theme }) =>
      theme.screenBreakpoints.large}) {
    height: 512px;
  }
`;

export const StyledInfo = styled.div`
  padding: ${props => props.theme.space[4]}px 0;
  margin: 0 ${props => props.theme.space[4]}px;
`;

export const StyledOldPrice = styled.span`
  text-decoration: line-through;
  text-decoration-color: ${({ theme }) => theme.color.disabled};
`;

export const StyledPriceWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledDescriptionWrapper = styled.div`
  white-space: pre-wrap;
  margin-bottom: ${({ theme }) => theme.space[2]}px;
`;

export const StyledTitleWrapper = styled.div`
  word-break: break-word;
`;

export const StyledBulkWrapper = styled.div<{ shouldShowBulk: boolean }>`
  display: flex;
  gap: ${({ theme }) => theme.space[2]}px;
  justify-content: ${({ shouldShowBulk }) => (shouldShowBulk ? 'space-between' : 'center')};
  width: 100%;
`;
